export const ACCIDENT_PERIODS = [
  { name: '10 днів', value: 10 },
  { name: '15 днів', value: 15 },
  { name: '30 днів', value: 30 },
  { name: '3 місяці', value: 90 },
  { name: '6 місяців', value: 180 },
  { name: '9 місяців', value: 270 },
  { name: '1 рік', value: 365 },
];

export const ACCIDENT_PERIOD_LABELS = {
  10: '10 днів',
  15: '15 днів',
  30: '30 днів',
  90: '3 місяці',
  180: '6 місяців',
  270: '9 місяців',
  365: '1 рік',
};

const LEGACY_PERIOD_MAP = {
  '10_days': 10,
  '15_days': 15,
  '30_days': 30,
  '1_month': 30,
  '3_month': 90,
  '6_month': 180,
  '9_month': 270,
  '12_month': 365,
  '1_year': 365,
};

export function normalizeAccidentPeriod(period) {
  if (period === null || period === undefined || period === '') return 365;
  if (typeof period === 'number') return period;
  const p = String(period).trim();
  if (LEGACY_PERIOD_MAP[p]) {
    return LEGACY_PERIOD_MAP[p];
  }
  const parsed = parseInt(p, 10);
  return isNaN(parsed) ? 365 : parsed;
}

export function formatAccidentPeriod(period) {
  if (!period) return '';
  const days = normalizeAccidentPeriod(period);
  return ACCIDENT_PERIOD_LABELS[days] || `${days} днів`;
}
